import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getProducts } from "../repositories/storeRep";

const initialState = {
  data: [],
  loading: false,
  error: null,
};
export const getProductsData = createAsyncThunk(
  "products",
  async (thunkAPI) => {
    const response = await getProducts();
    return response;
  }
);
export const productsSlice = createSlice({
  name: "products",
  initialState,
  extraReducers: {
    [getProductsData.pending]: (state) => {
      state.loading = true;
    },
    [getProductsData.fulfilled]: (state, action) => {
      state.loading = false;
      const data = [];
      action.payload.data.map((element) => {
        data.push(Object.values(element));
      });
      state.data = data;
    },
    [getProductsData.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default productsSlice.reducer;
